import { Outlet, Link } from "react-router-dom";
import { Grid } from "@mui/material";
import "./layout.css";

const Layout = () => {
  return (
    <>
      <div className="started">
        <h1>Ticketing</h1>
      </div>
      <Grid container className="ticketing-layout">
        <Grid item xs={12} md={2} className="navb-item">
          <div className="navb">
            <nav>
              <ul>
                <li>
                  <Link to="board">Board</Link>
                </li>

                <li>
                  <Link to="issues">Companies</Link>
                </li>
                <li>
                  <Link to="contracts">Contracts</Link>
                </li>
                <li>
                  <Link to="operators"> Maintenance Operators</Link>
                </li>
              </ul>
            </nav>
          </div>
        </Grid>
        <Grid item xs={12} md={10} className="layoutContainer">
          <Outlet />
        </Grid>
      </Grid>
    </>
  );
};

export default Layout;
